/*
 * @Author: liqiang70 liqiang70@58.com
 * @Date: 2025-05-14 16:05:40
 * @LastEditors: liqiang70 liqiang70@58.com
 * @LastEditTime: 2025-09-04 10:35:07
 * @Description: 
 */
import React, { useEffect, useState } from 'react'
import { Route, Routes } from "react-router-dom";
import routers from './Router';
import Header from '../components/Header';
import Footer from '../components/Footer';

interface ICommonPageProps {
    component: React.ComponentType<any>;
}

// 如果后期需要添加一下公用的方法，
const CommonPage = (props: ICommonPageProps) => {
    const C = props.component;
    return (
        <div style={{ height: "100%", display: 'flex', flexDirection: 'column' }}>
            <Header />
            <C {...props} />
            <Footer />
        </div>
    )
}

const MainRouter = () => {
    return (
        <Routes>
            {
                routers.map((item, index) => {
                    return (
                        <Route
                            key={index}
                            path={item.path}
                            element={<CommonPage component={item.component} />
                            } />
                    )
                })
            }
            {/* <Route path='*' element={
                <Navigate to="/home" replace/>
            }/> */}
        </Routes>
    )
}
const App = () => {

    return (
        <MainRouter />
    )
};

export default App;

